import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "create-page",
  id: "CreatePage",
  "dark-class": "create-page-dark"
}
const _hoisted_2 = { class: "head-controller-box" }
const _hoisted_3 = { class: "step-box" }
const _hoisted_4 = { class: "step-base" }
const _hoisted_5 = ["id", "onClick"]
const _hoisted_6 = { class: "serial-number" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "submit" }, "提交", -1)
const _hoisted_9 = {
  class: "form-box",
  id: "CreateForm"
}
const _hoisted_10 = ["id", "data-step-id"]
const _hoisted_11 = { class: "title-box" }
const _hoisted_12 = { class: "serial-number" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "step-content"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "prompt" }, "密码必须包含 1 个字母和 1 个数字，密码长度至少为 8 个字符，如需修改密码时输入任意字符或删除任意字符即可", -1)
const _hoisted_17 = { class: "form-box" }
const _hoisted_18 = {
  key: 1,
  class: "step-content"
}
const _hoisted_19 = {
  key: 0,
  class: "prompt"
}
const _hoisted_20 = {
  key: 1,
  class: "form-box"
}
const _hoisted_21 = {
  key: 2,
  class: "form-box"
}
const _hoisted_22 = { class: "operating-box" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_elem_form = _resolveComponent("elem-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "back-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBack && _ctx.onBack(...args)))
      }, [
        _createVNode(_component_elem_icon, {
          class: "icon",
          name: "back"
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formConfig.create, (conf, idx) => {
            return _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["item-box", { activity: idx === 0 }]),
              key: idx,
              id: 'StepItemBox-' + conf.name,
              onClick: ($event: any) => (_ctx.onScrollToStepBox('FromItemBox-' + conf.name))
            }, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(idx + 1) + ".", 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(conf.title), 1)
            ], 10, _hoisted_5)), [
              [_vShow, conf.where || true]
            ])
          }), 128))
        ])
      ]),
      _createElementVNode("button", {
        class: "submit-button",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, [
        _createVNode(_component_elem_icon, {
          class: "icon",
          name: "success_white"
        }),
        _hoisted_8
      ])
    ]),
    _createElementVNode("div", {
      class: "step-box",
      onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onStepBoxScroll && _ctx.onStepBoxScroll(...args))),
      id: "StepBox"
    }, [
      _createElementVNode("form", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formConfig.create, (conf, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item-box step-item",
            key: idx,
            id: 'FromItemBox-' + conf.name,
            "data-step-id": 'StepItemBox-' + conf.name
          }, [
            (_ctx.getConditionValue(conf.where))
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["item-base step-base", 'step-item-' + idx])
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.getStepNumber(idx)), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(conf.title), 1),
                    (conf.list)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "add-button",
                          onClick: ($event: any) => (_ctx.onChangeList('append', conf.name))
                        }, [
                          _createVNode(_component_elem_icon, {
                            class: "icon-box",
                            name: "add_blue"
                          })
                        ], 8, _hoisted_14))
                      : _createCommentVNode("", true)
                  ]),
                  (conf.type === 'PASSWORD')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                            return (_openBlock(), _createBlock(_component_elem_form, {
                              index: idx,
                              key: idx,
                              data: item,
                              config: conf,
                              value: _ctx.value,
                              onChangeData: _ctx.onChangeValue
                            }, null, 8, ["index", "data", "config", "value", "onChangeData"]))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        (conf.prompt)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(conf.prompt), 1))
                          : _createCommentVNode("", true),
                        (!conf.list)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                                return (_openBlock(), _createBlock(_component_elem_form, {
                                  index: idx,
                                  key: idx,
                                  data: item,
                                  config: conf,
                                  value: _ctx.value,
                                  onChangeData: _ctx.onChangeValue
                                }, null, 8, ["index", "data", "config", "value", "onChangeData"]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getStepMap(conf), (sub, sub_idx) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "list-box",
                                  key: sub.key_id
                                }, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(conf.data, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_elem_form, {
                                      entity: conf.name,
                                      index: sub_idx,
                                      key: sub.key_id + idx,
                                      data: item,
                                      config: conf,
                                      value: _ctx.value,
                                      onChangeData: _ctx.onChangeValue
                                    }, null, 8, ["entity", "index", "data", "config", "value", "onChangeData"]))
                                  }), 128)),
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "clear-button",
                                      onClick: ($event: any) => (_ctx.onChangeList('clear', conf.name, sub_idx))
                                    }, [
                                      _createVNode(_component_elem_icon, {
                                        class: "icon-box",
                                        name: "clear_red"
                                      })
                                    ], 8, _hoisted_23),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "add-button",
                                      onClick: ($event: any) => (_ctx.onChangeList('append', conf.name))
                                    }, [
                                      _createVNode(_component_elem_icon, {
                                        class: "icon-box",
                                        name: "add_blue"
                                      })
                                    ], 8, _hoisted_24)
                                  ])
                                ]))
                              }), 128))
                            ]))
                      ]))
                ], 2))
              : _createCommentVNode("", true)
          ], 8, _hoisted_10))
        }), 128))
      ])
    ], 32)
  ]))
}